import { render, staticRenderFns } from "./Thermometer.global.vue?vue&type=template&id=899db9b0&scoped=true&lang=pug&"
import script from "./Thermometer.global.vue?vue&type=script&lang=ts&"
export * from "./Thermometer.global.vue?vue&type=script&lang=ts&"
import style0 from "./Thermometer.global.vue?vue&type=style&index=0&id=899db9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899db9b0",
  null
  
)

export default component.exports